import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import FMPSelect from '../pureForm/FMPSelect';

const styles = () => {
	return {
		fetching: {
			fontStyle: 'italic',
			padding: '10px 0px',
			color: '#777',
		},
		date: {
			paddingRight: 10,
			marginRight: 10,
			borderRight: '1px solid #ccc',
			display: 'flex',
			alignItems: 'center',
			backgroundColor: '#f7f7f7',
		},
		freightType: {
			paddingRight: 10,
			marginRight: 10,
			borderRight: '1px solid #ccc',
			display: 'flex',
			alignItems: 'center',
		},
		dataLine: {
			fontSize: 13,
			color: '#444',
		},
		dataLineE85: {
			fontSize: 15,
			color: '#444',
		},
	};
};

const _f = (v) => {
	return parseFloat(v.toFixed(5));
};

class FMPStationQuotedPriceSelect extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			classes,
			stationQuotedPrices,
			showUnleadedPrice,
			usePdiForUnlPrice,
			dataDumpMap,
		} = this.props;

		if (_.isEmpty(stationQuotedPrices)) {
			return <div className={classes.fetching}>Fetching quoted prices...</div>;
		}

		const freightTypeMap = {
			freightFullLoad: 'Full Load',
			freightHalfLoadSplit: 'Split Half Load',
			freightHalfLoadNoSplit: 'No Split Half Load',
			deliveryAdder: 'Delivery Adder',
		};

		//let value, onChange, error;
		//const onChange = event => controller.onChange(event, path);

		const options = _.sortBy(stationQuotedPrices, 'date').map((quotedPrice) => {
			const {
				stationQuotedPriceId,
				date,
				freightType,
				productType,
				price,
				dataDumpId,
			} = quotedPrice;

			// const isE85 = (productType === 'e85');
			let fuelType = _.capitalize(productType) + ' Price';
			const displayDate = moment(date).format('M/D');

			let unlCost;
			if (showUnleadedPrice) {
				const dataDump = dataDumpMap[dataDumpId];

				unlCost = 'Missing data from date';
				if (dataDump) {
					const {
						ubdRackAvg,
						capAtTheRack,
						lcfsCost,
						pdiUnleaded,
						pdiUnleadedFormula,
					} = dataDump.data;
					if (usePdiForUnlPrice) {
						unlCost = _f(pdiUnleadedFormula || pdiUnleaded);
					} else {
						unlCost = _f(ubdRackAvg + capAtTheRack + lcfsCost);
					}
					//unlCost = `<strong>Unleaded Price</strong> : ${unlCost} (UBD Rack Avg : ${ubdRackAvg} / `;
				}
			}

			const hasFreightType = freightType && freightType !== 'none';

			return {
				value: stationQuotedPriceId,
				display: (
					<div style={{ display: 'flex' }}>
						<div className={classes.date}>{displayDate}</div>
						{hasFreightType && (
							<div className={classes.freightType}>
								Freight : {freightTypeMap[freightType] || '??'}
							</div>
						)}

						{!showUnleadedPrice && (
							<div>
								<strong>
									{fuelType} : {price}
								</strong>
							</div>
						)}
						{showUnleadedPrice && (
							<div style={{ lineHeight: '1.2' }}>
								<div className={classes.dataLineE85}>
									Quoted {fuelType}: {price}
								</div>
								<div className={classes.dataLine}>Quoted UNL Price: {unlCost}</div>
							</div>
						)}
					</div>
				),
			};
		});

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				md={md}
				helpText={helpText}
			/>
		);
	}
}

FMPStationQuotedPriceSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	md: PropTypes.number,
	helpText: PropTypes.string,
	stationQuotedPrices: PropTypes.array,

	showUnleadedPrice: PropTypes.bool,
	dataDumpMap: PropTypes.object,
	usePdiForUnlPrice: PropTypes.bool,
};

FMPStationQuotedPriceSelect.defaultProps = {
	md: 12,
	label: 'Quoted Prices',
};

export default _.flow([withStyles(styles)])(FMPStationQuotedPriceSelect);
